import Text from "components/base/Text";
import Button from "components/base/Button";
import VideoItem from "components/blocks/VideoItem";
import Trans from "components/base/Trans";
import {
  MotionContainer as Container,
  MotionGrid as Grid,
  MotionBox as Box,
  staggeredAppear,
  appearBelow,
} from "utils/motion";

export default function EpisodesSection({
  allEpisodes,
  loading,
  loadMore,
  onEpisodeClick,
}) {
  return (
    <Container
      initial="hidden"
      animate="visible"
      bg="black.900"
      id="presentation"
      variants={staggeredAppear}
      maxWidth="xl"
      pt={[8, null, 16]}
      pb={[16, null, 32]}
      px={[6, null, 20, 20, 20, 0]}
    >
      <Text
        type="headline_md"
        color="white"
        variants={appearBelow}
        mb={[6, null, 16]}
      >
        <Trans id="LBL_DOCUSERIES_EPISODES" />
      </Text>
      <Grid
        variants={appearBelow}
        templateColumns={["1fr", "1fr", "repeat(2, 1fr)", "repeat(3, 1fr)"]}
        gap={["xxl", "xxl", 6]}
      >
        {allEpisodes.results.map((episode) => (
          <VideoItem
            onClick={() =>
              onEpisodeClick(episode.data.feature_video, episode.uid)
            }
            color="white"
            variants={appearBelow}
            exit="hidden"
            key={episode.uid}
            uid={episode.uid}
            data={episode.data}
          />
        ))}
      </Grid>
      {allEpisodes.total_pages !== allEpisodes.page && (
        <Box mt={30} align="center">
          <Button
            isLoading={loading}
            loadingText={<Trans id="LBL_BLOG_LOADING" />}
            onClick={loadMore}
            variant="outline"
          >
            <Trans id="LBL_BLOG_LOAD_MORE" />
          </Button>
        </Box>
      )}
    </Container>
  );
}
